<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>All Subject Consolidated Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @change="putallnull()"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
                        getDiv();
                       putnull();
                        "
                        persistent-hint
                        hint="Please select standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="div"
                        item-value="div_off_id"
                        :items="div_list"
                        item-text="div_name"
                        label="Division"
                        outlined
                        persistent-hint
                        hint="Please select division"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="entrytype"
                        item-value="id"
                        :items="entrytype_list"
                        item-text="name"
                        label="Select Course Tpe"
                        outlined
                        persistent-hint
                        hint="Please select Course Tpe"
                    />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="status"
                        :items="status_list"
                        item-text="name"
                        item-value="id"
                        label="Status"
                        outlined
                        persistent-hint
                        hint="Select Status"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-checkbox dense v-model="show_ass_type" class="pt-4" color="success" label="Show Exam Wise Report" @change="emptyResult()"></v-checkbox>
                  </v-col>

                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && entrytype">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="result!=''">
                
                <v-row>
                    <v-btn class="ml-2 mr-2 mb-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                 <!-- <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2"> -->
                    <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                        <v-icon left color="success">mdi-export</v-icon>
                        Export
                    </v-btn>
                <!-- </v-col> -->
                </v-row>
                 <div id="printArea">
            <v-simple-table fixed-header height="500px" dense class="elevation-1" v-if="result!=''">
                <thead>
                    <tr class="header-row-1">
                        <th colspan="4" v-if="show_ass_type" class="freeze corner-blank"></th>
                        <th v-if="!show_ass_type" class="freeze c1">Sr.No.</th>
                        <th v-if="!show_ass_type" class="freeze c2">Roll No.</th>
                        <th v-if="!show_ass_type" class="freeze c3 text-left">Name</th>
                        <th v-if="!show_ass_type" class="freeze c4">Division</th>
                        <th class="" v-for="header,index in crs_list" :key="index" :colspan="crs_list_ass_details_size[index]">
                            <center>{{ header }}</center>
                        </th>
                        <th colspan="2" v-if="show_ass_type"></th>
                        <th v-if="!show_ass_type">Total / Out Off</th>
                        <th v-if="!show_ass_type">Percentage</th>
                    </tr>
                    <tr v-if="show_ass_type" class="header-row-2">
                        <th class="freeze c1">Sr.No.</th>
                        <th class="freeze c2">Roll No.</th>
                        <th class="freeze c3 text-left">Name</th>
                        <th class="freeze c4">Division</th>
                        <th class="" v-for="header,index1 in crs_list_ass_details" :key="index1">
                            <center>{{ header }}</center>
                        </th>
                        <th>Total / Out Off</th>
                        <th>Percentage</th>
                    </tr>
                </thead>
                <tbody style="overflow-y: scroll;">
                    <tr v-for="(s, index) in result" :key="index">
                        <td class="freeze c1">{{ index+1 }}</td>
                        <td class="freeze c2">{{ s.rollNo }}</td>
                        <td class="freeze c3 text-left">{{ s.name }}</td>
                        <td class="freeze c4">{{ s.division }}</td>
                        <td v-for="(m, index1) in s.marks" :key="index1">
                            <template v-if="m && m.includes('-')">
                                <span>{{ getMarks(m).marks }}</span>
                                <span class="grade-bold" v-if="show_grade">-{{ getMarks(m).grade }}</span>
                            </template>
                            <template v-else>
                                {{ m }}
                            </template>
                        </td>
                        <td>{{ s.total_marks }} / {{ s.out_off_marks }}</td>
                        <td>{{ s.percentage }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
        </div>
        </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import * as XLSX from "xlsx";
    export default {
        data() {
            return {
                loader: false,
                overlay: false,
                selected: [],
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                standard: null,
                division: null,
                course: null,
                academicyear: null,
                org_basic_data: [],
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: "0",
                entrytype_list: [],
                entrytype: null,
                crs_list_ass_details:[],
                crs_list_ass_details_size:[],
                crs_list_rubrics_details:[],
                crs_list_rubrics_details_size:[],
                result:[],
                crs_list:[],
                show_ass_type:true,
                show_grade:true
            };
        },

        methods: {
            emptyResult(){
                this.result = []
            },
            getMarks(val){
    const parts = val.split('-')
    return {
      marks: parts[0],
      grade: parts[1]
    }
  },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            putallnull() {
                this.div_list = null;
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            putnull3() {
                this.show = false;
            },
            // print() {
            //     this.$store.state.drawer = false;
            //     let that = this;
            //     window.onafterprint = function () {
            //         that.$store.state.drawer = true;
            //     };
            //     setTimeout(function () {
            //         window.print();
            //     }, 100);
            // },
            // print() {
            // const printContents = document.getElementById("printArea").innerHTML;
            // const htmlContent = `
            //     <html>
            //     <head>
            //         <title>&nbsp;</title>
            //         <style>
            //             @page {
            //                 size: auto;
            //                 margin: 0mm;
            //             }
            //             body {
            //                 font-family: Arial;
            //                 padding: 5px;
            //             }
            //             table {
            //                 width: 100% !important;
            //                 table-layout: fixed !important;
            //                 border-collapse: collapse;
            //                 margin-top: 5px;
            //             }
            //             #tab table, #tab1 table {
            //                 width: 100% !important;
            //             }
            //             #tab table {
            //                 margin-bottom: 10px;
            //             }
            //             th, td {
            //                 border: 1px solid black;
            //                 padding: 2px !important;
            //                 font-size: 8px !important;
            //                 text-align: center;
            //                 word-wrap: break-word;
            //             }
            //             img {
            //                 width: 40px !important;
            //                 height: auto;
            //                 display: block;
            //                 margin: auto;
            //             }
            //             h1, h2, h3, h4, h5, h6 {
            //                 margin: 0 !important;
            //                 padding: 0 !important;
            //             }
            //             h5{
            //                 font-size: 8px;
            //             }
            //         </style>
            //     </head>
            //     <body>
            //         ${printContents}
            //         <script>
            //             window.onload = function() {
            //                 window.print();
            //                 setTimeout(() => window.close(), 500);
            //             };
            //         <\/script>
            //     </body>
            //     </html>
            // `;

            // const blob = new Blob([htmlContent], { type: "text/html" });
            // const blobUrl = URL.createObjectURL(blob);
            // const printWindow = window.open(blobUrl, "_blank", "height=800,width=1200");

            // if (printWindow) {
            //     printWindow.onafterprint = function () {
            //         URL.revokeObjectURL(blobUrl);
            //         printWindow.close();
            //     };
            // }
            // },
            print() {
                const printContents = document.getElementById("printArea").innerHTML;
                const htmlContent = `
                    <html>
                    <head>
                        <meta charset="UTF-8">
                        <title>&nbsp;</title>
                        <style>
                            @page {
                                size: auto;
                                margin: 0mm;
                            }
                            body {
                                font-family: Arial, "Noto Sans", "Mangal", sans-serif;
                                padding: 5px;
                            }
                            table {
                                width: 100% !important;
                                table-layout: fixed !important;
                                border-collapse: collapse;
                                margin-top: 5px;
                            }
                            th, td {
                                border: 1px solid black;
                                padding: 2px !important;
                                font-size: 8px !important;
                                text-align: center;
                                word-wrap: break-word;
                            }
                            img {
                                width: 40px !important;
                                height: auto;
                                display: block;
                                margin: auto;
                            }
                            h1, h2, h3, h4, h5, h6 {
                                margin: 0 !important;
                                padding: 0 !important;
                            }
                            h5 { font-size: 8px; }

                            .grade-bold { font-weight: 700; }

                            .v-data-table__wrapper {
                                height: auto !important;
                                max-height: none !important;
                                overflow: visible !important;
                            }
                            .v-data-table--fixed-header thead th {
                                position: static !important;
                            }
                        </style>
                    </head>
                    <body>
                        ${printContents}
                        <script>
                            window.onload = function() {
                                window.print();
                                setTimeout(() => window.close(), 500);
                            };
                        <\/script>
                    </body>
                    </html>
                `;

                const blob = new Blob([htmlContent], { type: "text/html;charset=utf-8" });
                const blobUrl = URL.createObjectURL(blob);
                const printWindow = window.open(blobUrl, "_blank", "height=800,width=1200");

                if (printWindow) {
                    printWindow.onafterprint = function () {
                    URL.revokeObjectURL(blobUrl);
                    printWindow.close();
                    };
                }
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                    entrttype: this.entrytype,
                    status: this.status,
                    show_ass_type:this.show_ass_type
                };
                this.fetch_loader = true;
                axios
                    .post("/Examination/getAllSubjectMarksReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list_ass_details = res.data.crs_list_ass_details
                            this.crs_list_ass_details_size = res.data.crs_list_ass_details_size
                            this.result = res.data.result
                            this.crs_list = res.data.crs_list
                            this.show_grade = res.data.show_grade
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.show = true;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                        this.entrytype_list = ["All"];
                        this.entrytype_list = res.data.entrytype_list;
                        this.entrytype_list.unshift("All");
                        this.entrytype = this.entrytype_list[0];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            CartPdf() {
                var tab = document.getElementById("tab");
                var tab1 = document.getElementById("tab1");
                var win = window.open("", "", "height=700,width=1000");
                win.document.write(tab.outerHTML, tab1.outerHTML);
                win.document.close();
                win.print();
            },
            downloadFile() {
                this.loader = true;
                let sheetData = [];
                let headerRow1 = ["S.No", "Roll No", "Name", "Division"];

                this.crs_list.forEach((subject, i) => {
                    const count = this.crs_list_ass_details_size[i];

                    for (let j = 0; j < count; j++) {
                        headerRow1.push(j === 0 ? subject : "");
                    }
                });

                headerRow1.push("Total / Out Off", "Percentage");
                let headerRow2 = ["", "", "", ""];

                this.crs_list_ass_details.forEach((h) => {
                    headerRow2.push(h);
                });

                headerRow2.push("", "");
                sheetData.push(headerRow1);
                sheetData.push(headerRow2);

               
                this.result.forEach((item, index) => {
                    let row = [
                        index + 1,
                        item.rollNo,
                        item.name,
                        item.division
                    ];

                    item.marks.forEach((m) => {
                        row.push(m || "NA");
                    });

                    row.push(
                        `${item.total_marks} / ${item.out_off_marks}`,
                        item.percentage
                    );

                    sheetData.push(row);
                });

                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                let merges = [];
                let colIndex = 4;

                this.crs_list.forEach((subject, i) => {
                    const count = this.crs_list_ass_details_size[i];
                    merges.push({
                        s: { r: 0, c: colIndex },
                        e: { r: 0, c: colIndex + count - 1 }
                    });
                    colIndex += count;
                });

                merges.push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } });
                merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } });
                merges.push({ s: { r: 0, c: 2 }, e: { r: 1, c: 2 } });
                merges.push({ s: { r: 0, c: 3 }, e: { r: 1, c: 3 } });

                const lastCol = headerRow1.length - 1;

                merges.push({ s: { r: 0, c: lastCol - 1 }, e: { r: 1, c: lastCol - 1 } });
                merges.push({ s: { r: 0, c: lastCol }, e: { r: 1, c: lastCol } });

                ws["!merges"] = merges;

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Report");
                XLSX.writeFile(wb, "AllSubjectMarksReports.xlsx");
                this.loader = false;
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    .scroll {
        overflow-x: scroll;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(
            to right,
            #2c5364,
            #203a43,
            #0f2027
        ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    .elevation-1 >>> table {
        border-collapse: separate !important;
        border-spacing: 0 !important;
        table-layout: fixed !important;
        width: max-content !important;
    }

    .elevation-1 >>> .header-row-1,
    .elevation-1 >>> .header-row-2 {
        background-color: #fff;   
    }

    .elevation-1 >>> .header-row-1 th {
        position: sticky !important;
        top: 0 !important;
        z-index: 4 !important;
        height: 28px !important;
        line-height: 1.1 !important;
        background-color: #fff !important;
        box-shadow: inset 0 -1px 0 #ccc; 
    }

    .elevation-1 >>> .header-row-2 th {
        position: sticky !important;
        top: 28px !important;   
        z-index: 3 !important;
        height: 28px !important;
        line-height: 1.1 !important;
        background-color: #fff !important;
        box-shadow: inset 0 -1px 0 #ccc, inset 0 1px 0 #ccc;
    }
    .elevation-1 >>> .freeze {
        position: sticky !important;
        background-color: #fff !important;
        z-index: 5;
        box-sizing: border-box !important;
    }

    .elevation-1 >>> .c1 { left: 0px;   width: 80px;  min-width: 80px;  max-width: 80px; }
    .elevation-1 >>> .c2 { left: 80px;  width: 90px;  min-width: 90px;  max-width: 90px; }
    .elevation-1 >>> .c3 { left: 170px; width: 160px; min-width: 160px; max-width: 160px; }
    .elevation-1 >>> .c4 { left: 330px; width: 90px;  min-width: 90px;  max-width: 90px; box-shadow: inset -1px 0 0 #ccc; }

    .elevation-1 >>> .header-row-1 th.freeze,
    .elevation-1 >>> .header-row-2 th.freeze {
        z-index: 10 !important;
        background-color: #fff !important;
    }

    .elevation-1 >>> .corner-blank {
        left: 0px;
        width: 420px !important;
        min-width: 420px !important;
        max-width: 420px !important;
        box-sizing: border-box !important;
    }

    .elevation-1 >>> .header-row-1 th.freeze {
        z-index: 10 !important;
        background-color: #fff !important;
    }

    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: small !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
    .grade-bold {
    font-weight: 700;
    }
</style>
